import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Annuaire() {
  const [form, setForm] = useState({ nom: '', email: '', profession: '', message: '' })
  const [envoye, setEnvoye] = useState(false)
  const [erreur, setErreur] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!form.email.trim()) return
    setLoading(true)
    setErreur('')
    const { error } = await supabase.from('emails_pro').insert({
      email: form.email.trim(),
      nom: form.nom.trim() || null,
      profession: form.profession.trim() || null,
      message: form.message.trim() || null
    })
    setLoading(false)
    if (error) { setErreur('Une erreur est survenue. Réessayez.'); return }
    setEnvoye(true)
  }

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        {/* Badge en construction */}
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <span style={badgeStyle}>🚧 En construction</span>
        </div>

        {/* Titre */}
        <h1 style={h1Style}>L'annuaire des professionnels du TDAH</h1>

        {/* Punchline */}
        <p style={punchlineStyle}>
          Ici, on construit un réseau professionnel puissant pour vous aider,
          vous, parents des petits génies TDAH.
        </p>

        <div style={separatorStyle} />

        {/* Explication */}
        <p style={descStyle}>
          Orthophonistes, psychomotriciens, neuropsychologues, ergothérapeutes, coachs TDAH…
          Nous créons un annuaire de professionnels de confiance, directement intégré à KudoGenius,
          pour que chaque famille trouve le bon accompagnement près de chez elle.
        </p>

        {/* Formulaire ou message de confirmation */}
        {envoye ? (
          <div style={successStyle}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>🎉</div>
            <p style={{ fontWeight: 700, color: '#166534', fontSize: 16, marginBottom: 4 }}>Merci pour votre intérêt !</p>
            <p style={{ color: '#15803d', fontSize: 13 }}>
              Nous vous contacterons dès que l'annuaire sera prêt.
            </p>
          </div>
        ) : (
          <>
            <div style={ctaBoxStyle}>
              <h2 style={ctaTitleStyle}>🩺 Vous êtes professionnel du TDAH ?</h2>
              <p style={{ fontSize: 13, color: '#475569', marginBottom: 16, lineHeight: 1.6 }}>
                Rejoignez le projet et soyez parmi les premiers référencés.
                Laissez-nous vos coordonnées, on vous recontacte.
              </p>

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <input
                  type="text"
                  placeholder="Votre nom"
                  value={form.nom}
                  onChange={e => setForm({ ...form, nom: e.target.value })}
                  style={inputStyle}
                />
                <input
                  type="email"
                  placeholder="Votre email *"
                  required
                  value={form.email}
                  onChange={e => setForm({ ...form, email: e.target.value })}
                  style={inputStyle}
                />
                <input
                  type="text"
                  placeholder="Votre profession (ex: neuropsychologue)"
                  value={form.profession}
                  onChange={e => setForm({ ...form, profession: e.target.value })}
                  style={inputStyle}
                />
                <textarea
                  placeholder="Un mot sur votre intérêt pour le projet (optionnel)"
                  value={form.message}
                  onChange={e => setForm({ ...form, message: e.target.value })}
                  rows={3}
                  style={{ ...inputStyle, resize: 'vertical' }}
                />
                <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, cursor: 'pointer', fontSize: 11, color: '#64748b', lineHeight: 1.5 }}>
                  <input type="checkbox" required style={{ marginTop: 3, accentColor: '#2563eb' }} />
                  <span>
                    J'accepte que mes données soient traitées conformément à la{" "}
                    <a href="/politique-confidentialite" target="_blank" style={{ color: '#2563eb', textDecoration: 'underline' }}>
                      politique de confidentialité
                    </a>.
                  </span>
                </label>
                {erreur && <p style={{ color: '#dc2626', fontSize: 12 }}>{erreur}</p>}
                <button type="submit" disabled={loading} style={btnStyle}>
                  {loading ? 'Envoi...' : 'Je suis intéressé(e) →'}
                </button>
              </form>
            </div>
          </>
        )}

        {/* Footer */}
        <div style={{ textAlign: 'center', marginTop: 32 }}>
          <p style={{ fontSize: 12, color: '#94a3b8', marginBottom: 12 }}>
            Vous êtes parent ?{' '}
            <Link to="/connexion" style={{ color: '#2563eb', fontWeight: 600 }}>Accéder à KudoGenius</Link>
          </p>
          <p style={{ fontSize: 11, color: '#cbd5e1' }}>
            <Link to="/mentions-legales" style={{ color: '#cbd5e1' }}>Mentions légales</Link>
            <span style={{ margin: '0 8px' }}>·</span>
            <Link to="/politique-confidentialite" style={{ color: '#cbd5e1' }}>Confidentialité</Link>
          </p>
        </div>
      </div>
    </div>
  )
}

const containerStyle = {
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563eb 100%)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: 20, fontFamily: "'Inter', sans-serif"
}
const cardStyle = {
  background: '#fff', borderRadius: 20, padding: '44px 36px',
  maxWidth: 560, width: '100%',
  boxShadow: '0 24px 80px rgba(0,0,0,0.2)'
}
const badgeStyle = {
  display: 'inline-block', background: '#fef3c7', color: '#92400e',
  borderRadius: 20, padding: '6px 16px', fontSize: 13, fontWeight: 700
}
const h1Style = {
  fontFamily: "'Playfair Display', serif", fontSize: 26, fontWeight: 900,
  color: '#1e293b', textAlign: 'center', lineHeight: 1.3, marginBottom: 12
}
const punchlineStyle = {
  fontSize: 15, color: '#475569', textAlign: 'center',
  lineHeight: 1.6, fontWeight: 500, fontStyle: 'italic'
}
const separatorStyle = {
  width: 60, height: 3, background: 'linear-gradient(90deg, #2563eb, #7c3aed)',
  borderRadius: 2, margin: '24px auto'
}
const descStyle = {
  fontSize: 14, color: '#64748b', textAlign: 'center',
  lineHeight: 1.7, marginBottom: 28
}
const ctaBoxStyle = {
  background: '#f8fafc', borderRadius: 16, padding: '24px',
  border: '1px solid #e2e8f0'
}
const ctaTitleStyle = {
  fontSize: 17, fontWeight: 800, color: '#1e293b',
  marginBottom: 8, textAlign: 'center'
}
const inputStyle = {
  width: '100%', padding: '12px 14px', borderRadius: 10,
  border: '1.5px solid #e2e8f0', fontSize: 14,
  fontFamily: "'Inter', sans-serif", outline: 'none',
  boxSizing: 'border-box'
}
const btnStyle = {
  width: '100%', padding: '13px', borderRadius: 10, border: 'none',
  background: 'linear-gradient(135deg, #1e3a5f, #2563eb)',
  color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer',
  fontFamily: "'Inter', sans-serif"
}
const successStyle = {
  textAlign: 'center', padding: '28px 20px',
  background: '#f0fdf4', borderRadius: 16,
  border: '1px solid #bbf7d0'
}
